import { App, NavController, NavParams,LoadingController, ToastController } from 'ionic-angular';
import { ApiService } from '../../api-service/api-service';

import { Component, ViewChild } from '@angular/core';
import { Content } from 'ionic-angular';
import { Events } from 'ionic-angular';

import { User,UserPost,UserComment,UserData } from '../../providers/providers';

declare var AWS: any;
declare const aws_user_files_s3_bucket;
declare const aws_user_files_s3_bucket_region;
const url = 'http://cdn.chitika.net/getads.js';

@Component({
  templateUrl: 'vote-bank.html'
})
export class VoteBankPage {

  items:UserComment[] = [];


  private s3: any;
  public sub: string = null;
  public lastKey: any = "";
  public IScroll:any;
  public commentMessage:string = "";
  private postId:string;
  public timeLeft:number = 60;
  public hours:number;
  public minutes:number;
  public seconds:number;
  public bankFull:boolean = false;
  private timerStarted:boolean = false;

  private userRefreshed:boolean = false;
  loaderMessage:any;

  loadAPI: Promise<any>;
  public placement_id:number;
  public bannerId:string = "not set";
  

  constructor(public navCtrl: NavController,public navParams:NavParams,public server:ApiService,
    public user:User,public loadingCtrl: LoadingController,
    public toastCtrl: ToastController, public userData:UserData, private events: Events) {
      
        if (navParams.get('userPostId')){
            this.postId = navParams.get('userPostId');
        }
        this.userData.refreshUserData();
        this.setUserRefreshedData();

        events.subscribe('user-refreshed', (refreshedUser) => {
          this.setUserRefreshedData();
        });
      

        this.server.checkVoteGenerator(this.checkBankCallBack);

        //var timer = this.StartTimerCountdown();


  }

 /* ngOnInit(){
    this.loadAPI = new Promise((resolve) => {
        console.log('resolving promise...');
        //this.loadScript();
    });
}

public loadScript() {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    this.chitikaAddHeight();
}

chitikaAddHeight(){
  if (window['CHITIKA'] === undefined) { window['CHITIKA'] = { 'units' : [] }; };
        var unit = {"calltype":"async[2]","publisher":"picladder","width":320,"height":50,"sid":"Chitika Default"};
        this.placement_id = window['CHITIKA'].units.length;
        window['CHITIKA'].units.push(unit);
        this.bannerId = "chitikaAdBlock-"+this.placement_id.toString();
        //document.write('<div id="chitikaAdBlock-' + this.placement_id + '"></div>');
}
*/

  private StartTimerCountdown() {
    this.timerStarted = true;
    return setInterval(() => {
      if (this.timeLeft != 0) {
        this.timeLeft -= 1;
        this.countDownSecond();
      }
      else {
        this.server.checkVoteGenerator(this.checkBankCallBack);
      }
    }, 1000);
  }

  countDownSecond(){
    this.seconds -= 1;
    let tickMinute = false;
    let tickHour = false;
    let checkGenerator = false;
    if(this.hours === 0 && this.minutes === 0 && this.seconds === 0){
      if(this.userRefreshed === false)
      {
        this.server.checkVoteGenerator(this.checkBankCallBack);
      }
    }

    if(this.seconds === 0){
       tickMinute = true;
       this.seconds = 59;
    }
    if(tickMinute === true){
      if(this.minutes === 0){
        this.minutes = 59;
        tickHour = true;
      }
      else{
      this.minutes -= 1
      }
      tickMinute = false;
    }
    if(tickHour === true ){
      this.hours -= 1;
      tickHour = false;
    }

    if(this.hours < 0){
      this.server.checkVoteGenerator(this.checkBankCallBack);
    }



  }

  getGeneratorCountdown(generatorResetDate:string){
    let resetDate = new Date(generatorResetDate);
    resetDate.setUTCHours(resetDate.getUTCHours() + 4);
    let currentTimeISO = new Date().toISOString();
    let currentTime = new Date(currentTimeISO);
    this.timeLeft = ( resetDate.getTime() - currentTime.getTime()) / 1000;

    //let seocondsDate = new Date(null);
    //seocondsDate.setSeconds(this.timeLeft);
    let workingSeconds = this.timeLeft;
    this.hours = Math.floor(workingSeconds / 60 / 60);
    let hoursMins = this.hours * 60 * 60;
    workingSeconds = workingSeconds - hoursMins;
    if(workingSeconds > 60)
    {
      this.minutes = Math.floor(workingSeconds / 60);
    }
    else
    {
      this.minutes = 0;
    }
    let minsSeconds = this.minutes * 60;
    workingSeconds = Math.floor(workingSeconds - minsSeconds);
    this.seconds = workingSeconds;

    if(!this.timerStarted){
      var timer = this.StartTimerCountdown();
    }
    
  }

  emptyBank(){
      if(this.userData.votes === this.userData.votesMax){
        alert('Votes full!  Cast some votes and come back later');
      }
      else
      {
      this.loaderMessage = this.loadingCtrl.create({
        content: 'Emptying Bank...'
      });
      this.loaderMessage.present();

      this.server.EmptyVoteGenerator(this.emptyBankCallBack);
    }
  }

    //Fat arrow used to keep scope, private entry back in
    public emptyBankCallBack = (data) => {
      this.bankEmptied(data);
    }
  
    bankEmptied(data){
      //TODO check if it returns something other than 'Not Ready' and refresh user
      //let tester = data;
      if(data !== "Not Ready"){
        this.userData.refreshUserData();
        //this.server.checkVoteGenerator(this.checkBankCallBack);
      }
      this.loaderMessage.dismiss();
    }

  //Fat arrow used to keep scope, private entry back in
  public checkBankCallBack = (data) => {
    this.bankChecked(data);
  }

  bankChecked(data){
    //TODO check if it returns something other than 'Not Ready' and refresh user
    //let tester = data;
    if(data !== "Not Ready"){
      this.userData.refreshUserData();
    }
  }

  setUserRefreshedData(){
    if(this.userData.voteGeneratorMax === this.userData.voteGenerator)
    {
      this.bankFull = true;
      //this.timer = null;
    }
    else
    {
      this.bankFull = false;
      this.getGeneratorCountdown(this.userData.voteTimerReset);
    }
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/vote-bank/vote-bank.ts